import React, { useState } from 'react';

import AddOnsDialog from '.';
import useConfirmationDialogV2 from '../../../../../../commons/dialogV2/useConfirmationDialogV2';

function useAddOnsDialog (props = {}) {
    const { open: defaultOpen = false, onAdded } = props;

    const [open, setOpen] = useState(defaultOpen);

    const { openDialog: openSuccessDialog, renderDialog: renderSuccessDialog } = useConfirmationDialogV2({
        onConfirm: onAdded,
        onClose: onAdded, // Escape/backdrop dismissal must not skip the post-success callback
        showPrimaryButton: true,
        showSecondaryButton: false,
        confirmLabel: 'Ok',
    });

    function renderDialog () {
        return (
            <React.Fragment>
                {open && (
                    <AddOnsDialog
                        open={open}
                        onClose={() => {
                            setOpen(false);
                        }}
                        onPaymentSuccess={openSuccessDialog}
                    />
                )}
                {renderSuccessDialog()}
            </React.Fragment>
        );
    }

    function openDialog () {
        setOpen(true);
    }

    return {
        renderDialog,
        openDialog,
    };
}

export default useAddOnsDialog;
